"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _utils = require("../../theme/utils");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var sizeStyle = function sizeStyle(props) {
  var size = props.size || 'medium';
  var data = props.theme.text[size];

  if (data) {
    return (0, _styledComponents.css)(["font-size:", ";line-height:", ";"], data.size, data.height);
  }

  return (0, _styledComponents.css)(["font-size:", ";line-height:normal;"], size);
};

var weightStyle = (0, _styledComponents.css)(["font-weight:", ";"], function (props) {
  return props.weight;
});

var setColor = function setColor(props) {
  var propsColor = props.color;
  var color = props.theme.colorDefault;

  if (props.primary) {
    color = props.theme.colorPrimary;
  }

  if (props.secondary) {
    color = props.theme.colorSecondary;
  }

  if (propsColor) {
    color = propsColor;
  }

  return (0, _styledComponents.css)(["color:", ";", "        "], color, !props.disabled && (0, _styledComponents.css)(["&:hover{color:", ";}"], (0, _utils.fadeColor)(color, 20)));
};

var disabledStyle = "\n  opacity: 0.4;\n  cursor: default;\n  text-decoration: none;\n";

var A = _styledComponents["default"].a.withConfig({
  displayName: "Anchor__A",
  componentId: "kbzdzc-0"
})(["box-sizing:border-box;cursor:pointer;outline:none;text-decoration:", ";", " ", " ", " ", " ", " ", ""], function (props) {
  return props.theme.anchor.textDecoration;
}, function (props) {
  return setColor(props);
}, function (props) {
  return sizeStyle(props);
}, function (props) {
  return props.weight && weightStyle;
}, function (props) {
  return props.uppercase && "\n      text-transform: uppercase;\n    ";
}, function (props) {
  return !props.disabled && props.theme.anchor.hover && (0, _styledComponents.css)(["&:hover{", "}"], props.theme.anchor.hover.textDecoration && "text-decoration: ".concat(props.theme.anchor.hover.textDecoration, ";"));
}, function (props) {
  return props.disabled && disabledStyle;
});

var Anchor = function Anchor(props) {
  var forwardRef = props.forwardRef,
      rest = _objectWithoutProperties(props, ["forwardRef"]);

  return /*#__PURE__*/_react["default"].createElement(A, _extends({
    ref: forwardRef
  }, rest));
};

var _default = Anchor;
exports["default"] = _default;